import React from "react";
import ParameterProgressBar from "./ParameterProgressBar";

export default function ConsistencyAnalysis({ score }) {
  return (
    <div className="mb-2">
      <h4 className={"text-color-gray-dark"}> Tutarlılık ve Yönelme Analizi</h4>
      <ParameterProgressBar name="Tutarlılık Skoru" score={score} />
    </div>
  );
}
